/* eslint-disable */
import Image from "next/image";

import AEDIcon from "@/assets/images/icons/AED.svg";
import AUDIcon from "@/assets/images/icons/AUD.svg";
import BHDIcon from "@/assets/images/icons/BHD.svg";
import BNDIcon from "@/assets/images/icons/BND.svg";
import BRLIcon from "@/assets/images/icons/BRL.svg";
import CADIcon from "@/assets/images/icons/CAD.svg";
import CHFIcon from "@/assets/images/icons/CHF.svg";
import CNYIcon from "@/assets/images/icons/CNY.svg";
import EURIcon from "@/assets/images/icons/EUR.svg";
import GBPIcon from "@/assets/images/icons/GBP.svg";
import HKDIcon from "@/assets/images/icons/HKD.svg";
import IDRIcon from "@/assets/images/icons/IDR.svg";
import JPYIcon from "@/assets/images/icons/JPY.svg";
import KRWIcon from "@/assets/images/icons/KRW.svg";
import KWDIcon from "@/assets/images/icons/KWD.svg";
import LKRIcon from "@/assets/images/icons/LKR.svg";
import MYRIcon from "@/assets/images/icons/MYR.svg";
import NOKIcon from "@/assets/images/icons/NOK.svg";
import NPRIcon from "@/assets/images/icons/NPR.svg";
import NZDIcon from "@/assets/images/icons/NZD.svg";
import OMRIcon from "@/assets/images/icons/OMR.svg";
import PHPIcon from "@/assets/images/icons/PHP.svg";
import QARIcon from "@/assets/images/icons/QAR.svg";
import RUBIcon from "@/assets/images/icons/RUB.svg";
import SARIcon from "@/assets/images/icons/SAR.svg";
import SEKIcon from "@/assets/images/icons/SEK.svg";
import SGDIcon from "@/assets/images/icons/SGD.svg";
import THBIcon from "@/assets/images/icons/THB.svg";
import USDIcon from "@/assets/images/icons/USD.svg";
import ZARIcon from "@/assets/images/icons/ZAR.svg";
import DKKIcon from "@/assets/images/icons/DKK.svg";

interface CurrencyImageProps {
  currencyCode: string;
  isFullFormRequired: boolean;
  className?: string;
}

interface CurrencyData {
  currency: string;
  imagePath: string;
  currencyCode: string;
}

const CurrencyIcon = (props: CurrencyImageProps) => {
  const { currencyCode, isFullFormRequired, className } = props;
  const getImagePath = (code: string): CurrencyData | null => {
    const currencyImageMapping: { [key: string]: any } = {
      GBP: GBPIcon,
      USD: USDIcon,
      EUR: EURIcon,
      JPY: JPYIcon,
      CNY: CNYIcon,
      AUD: AUDIcon,
      CAD: CADIcon,
      CHF: CHFIcon,
      HKD: HKDIcon,
      SGD: SGDIcon,
      AED: AEDIcon,
      SAR: SARIcon,
      MYR: MYRIcon,
      THB: THBIcon,
      NZD: NZDIcon,
      SEK: SEKIcon,
      KRW: KRWIcon,
      NOK: NOKIcon,
      ZAR: ZARIcon,
      BRL: BRLIcon,
      IDR: IDRIcon,
      PHP: PHPIcon,
      RUB: RUBIcon,
      QAR: QARIcon,
      OMR: OMRIcon,
      KWD: KWDIcon,
      BHD: BHDIcon,
      LKR: LKRIcon,
      BND: BNDIcon,
      NPR: NPRIcon,
      DKK: DKKIcon,
    };

    const currencyCodeMapping: { [key: string]: string } = {
      USD: "USD - U.S Dollar",
      EUR: "EUR - Euro",
      JPY: "JPY - Japanese Yen",
      GBP: "GBP - British Pound Sterling",
      CNY: "CNY - Chinese Yuan",
      AUD: "AUD - Australian Dollar",
      CAD: "CAD - Canadian Dollar",
      CHF: "CHF - Swiss Franc",
      HKD: "HKD - Hong Kong Dollar",
      SGD: "SGD - Singapore Dollar",
      AED: "AED - U.A.E Dirham",
      SAR: "SAR - Saudi Riyal",
      MYR: "MYR - Malaysian Ringgit",
      THB: "THB - Thai Baht",
      NZD: "NZD - New Zealand Dollar",
      SEK: "SEK - Swedish Krona",
      KRW: "KRW - South Korean Won",
      NOK: "NOK - Norwegian Krone",
      ZAR: "ZAR - South African Rand",
      BRL: "BRL - Brazilian Real",
      IDR: "IDR - Indonesian Rupiah",
      PHP: "PHP - Philippine Peso",
      RUB: "RUB - Russian Ruble",
      QAR: "QAR - Qatari Riyal",
      OMR: "OMR - Omani Rial",
      KWD: "KWD - Kuwaiti Dinar",
      BHD: "BHD - Bahraini Dinar",
      LKR: "LKR - Sri Lankan Rupee",
      BND: "BND - Brunei Dollar",
      NPR: "NPR - Nepalese Rupee",
      DKK: "DKK - Danish Krone",
    };

    const image = currencyImageMapping[code];
    const currency = isFullFormRequired
      ? currencyCodeMapping[code]
      : Object.keys(currencyImageMapping)?.find((key) => key === code) || "";

    if (image) {
      const imagePath = image;
      return { currency, imagePath, currencyCode: code };
    }
    return null;
  };

  const currencyData = getImagePath(currencyCode);

  if (currencyData) {
    const { currency, imagePath, currencyCode } = currencyData;
    return (
      <div className="d-flex align-items-center">
        <Image
          style={{ color: undefined }}
          src={imagePath}
          alt={`Flag for ${currencyCode}`}
          width={20}
          height={20}
          className="mr-1"
        />
        <p className={`text--black text--regular order__value ${className}`}>
          {currency}
        </p>
      </div>
    );
  }

  return (
    <>
      <div>
        <p className={`d-flex align-items-center ${className}`}>
          {currencyCode}
        </p>
      </div>
    </>
  );
};

export default CurrencyIcon;
